import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-method-input"
export default class extends Controller {
  static targets = ["hiddenCashInput", "paymentMethodInputs"];
  static values = {
    cashPlaceholder: String,
  };

  toggleEnableCashInput(event) {
    const enableCash = event.target.checked;
    this.hiddenCashInputTarget.value = enableCash ? this.cashPlaceholderValue : null;
  }

  togglePaymentMethodInputs(event) {
    const acceptsPayments = event.target.value;
    this.paymentMethodInputsTarget.classList.toggle("hidden", acceptsPayments === "false");
  }
}
